import { PaginationPayload } from 'app/shared/pagination/models';

const BASE = ['dispositions'] as const;

export const DISPOSITION_QUERY_KEYS = {
  getAllDispositions: () => [...BASE, 'list'] as const,
  getDispositions: (payload: PaginationPayload) =>
    [...DISPOSITION_QUERY_KEYS.getAllDispositions(), payload] as const,
};
